/* eslint-disable */
import { type Dayjs } from "dayjs";
import { ChartTooltipTotal } from "@similarweb/ui-components";
import { abbrNumberFilter, percentageSignFilter } from "app/filters/ngFilters";
import { colorsPalettes } from "@similarweb/styles";
import { translate } from "app/filters/i18nFilter";
import { GraphType } from "app/common/keyword-research/clicks-over-time-graph/graphTypes";
import { ITransformedDataPoint } from "app/common/keyword-research/clicks-over-time-graph/graphDataUtils";
import { getTooltipHeader } from "app/UtilitiesAndConstants/UtilitiesComponents/chartTooltipHeaderWithMTDSupport";
import { GranularityNames } from "app/UtilitiesAndConstants/Constants/Moment";
import { IDurationObject } from "app/services/DurationService";

import { JSX } from "react";
import { SourceTypeMap } from "app/UtilitiesAndConstants/Constants/SourceTypes";
import styled from "styled-components";

import { IGraphTitles } from "app/common/keyword-research/clicks-over-time-graph/graphDataUtils";
import {
    HeadersContainer,
    RowsContainer,
    TotalContainer,
    RowContainer,
    TooltipEntityContainer,
    TooltipRowText,
} from "@similarweb/ui-components";
import { EGraphGranularities, graphGranularityToString } from "app/common/keyword-research/serp-players/consts";

export const TooltipWrapperStyled = styled.div<{ width: string }>`
    ${(props) => ({ width: props.width })};
    ${HeadersContainer} > span:not(:first-child) {
        display: block;
        width: 100%;
        text-align: end;
    }
    ${RowsContainer} > div > *:not(:first-child) {
        display: block;
        width: 100%;
        text-align: end;
    }
    ${TotalContainer} ${RowContainer} > span:not(:first-child) {
        text-align: end;
        width: 100%;
    }
    ${RowsContainer} ${TooltipEntityContainer} ${TooltipRowText} {
        width: 180px;
    }
`;

export const useGraphTooltip =
    (
        percentageData: ITransformedDataPoint[],
        transformedData: ITransformedDataPoint[],
        graphType: GraphType,
        selectedGranularity: EGraphGranularities,
        durationData: IDurationObject<Dayjs>,
        sourceType: string,
        graphTitles: IGraphTitles,
    ) =>
    (_position: number, date: number | string, alertMessage = null, annotationBanner?: JSX.Element) => {
        const hasData = transformedData.length && percentageData.length && transformedData.length;
        if (!hasData) return;

        const timestamp = Number(date);
        const rows = transformedData
            .filter((legendDataPoint) => legendDataPoint.visible || legendDataPoint.isTotal || legendDataPoint.isOther)
            .map((legendDataPoint) => {
                const dataPoint = legendDataPoint.data.find((point) => point.x === timestamp);
                if (!dataPoint) {
                    return;
                }

                const percentagePoint = percentageData
                    .find((dataPoint) => dataPoint.name === legendDataPoint.name)
                    ?.data.find((point) => point.x === timestamp);
                const secondValue = !legendDataPoint.isTotal
                    ? percentageSignFilter()(percentagePoint?.y ?? 0, 0)
                    : percentageSignFilter()(1);

                return {
                    displayName: legendDataPoint.name,
                    isTotal: legendDataPoint.isTotal,
                    isOther: legendDataPoint.isOther,
                    color: legendDataPoint.color,
                    // @ts-expect-error FIXME: Argument of type 'number' is not assignable to parameter of type 'boolean'
                    firstValue: abbrNumberFilter()(dataPoint.y, 10),
                    secondValue: <span style={{ color: colorsPalettes.carbon[300] }}>{secondValue}</span>,
                };
            });

        return (
            <TooltipWrapperStyled width="340px">
                <ChartTooltipTotal
                    title={getTooltipHeader(
                        graphGranularityToString[selectedGranularity] as GranularityNames,
                        [{ x: date }],
                        durationData.to.valueOf() as any,
                        false,
                        alertMessage,
                    )}
                    columnsSize="54% 23% 23%"
                    rows={rows.filter((row) => row && !row.isTotal && !row.isOther)}
                    total={rows.find((row) => row && (graphType === "chart-stacked-share" ? row.isOther : row.isTotal))}
                    headers={[
                        translate(graphTitles.tooltipTitle),
                        translate(
                            `keywordanalysis.organic2.clicks.over.time.tooltip.${
                                sourceType ?? SourceTypeMap.Organic
                            }.clicks`,
                        ),
                        translate("keywordanalysis.organic2.clicks.over.time.tooltip.share.of.total"),
                    ]}
                />
                {annotationBanner && annotationBanner}
            </TooltipWrapperStyled>
        );
    };
